import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { SUPPORTED_LANG } from './Constants/constants';
import resources from './locales';

const LANGUAGE_STORAGE_KEY = 'nternow_language';

const getInitialLanguage = (): string => {
  try {
    const savedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return savedLanguage === SUPPORTED_LANG.ES ? SUPPORTED_LANG.ES : SUPPORTED_LANG.EN;
  } catch {
    return SUPPORTED_LANG.EN;
  }
};

i18n.on('languageChanged', language => {
  if (language !== SUPPORTED_LANG.EN && language !== SUPPORTED_LANG.ES) return;

  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // Storage may be unavailable; in-memory language switching still works.
  }
});

void i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: SUPPORTED_LANG.EN,
    interpolation: {
      escapeValue: false // react already escapes by default
    }
  });

export default i18n;
